<div class="container card-body table-responsive">
  <div *ngIf="ambienteNivelSuperior">  

    <h4>OBJETIVOS:
    {{ambienteNivelSuperior.nombreUnidad}}</h4>
  </div>
  
  <form id="formObjetivosView" [formGroup]="formEstrategia" autocomplete="off">
    <table class="table  table-bordered row-border hover">
      <ng-container *ngFor="let row of dataObjetivosAnios; index as indice" style="width: 100%">
        <thead class="table-secondary">
          <tr>
            <td colspan="2">Objetivo:.- {{row.nombre}} </td>
          </tr>
        </thead>
        <ng-container *ngFor="let fila of row.estrategias; index as i" style="width: 100%">
          <tbody>
            <tr *ngIf="fila.idSprEstrategia != null">
              <td class="size">{{i+1}} </td>
              <td colspan="4" class="checkbox">
                <input type="checkbox" class="form-check-input" [disabled]="deshabilitarEditar"
                  (change)="onChangeEstrategia($event)" id={{fila.idSprEstrategia}} name="option1{{indice}}"
                  value={{fila.idSprEstrategia}} [checked]="verifyChecked(fila,estraregiasObjetivoSeleccionado)">

                <label for={{fila.idSprEstrategia}} class="form-check-label">
                  {{fila.nombre}}
                </label>
              </td>
            </tr>
          </tbody>
        </ng-container>
      </ng-container>
    </table>
    <div *hasDenied="{nivel:idSprNivel, app: constant.OBJETIVOS_ESTRATEGIAS}">
      <div class="modal-footer">
        <button *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.ACTUALIZAR]}" type="button"
          class="btn btn-secondary waves-effect" (click)="habilitarEditar()">Editar</button>

        <button *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.CREAR]}" type="button" class="btn btn-info"
          (click)="onSubmitEstrategia(estraregiasObjetivoSeleccionado)">Guardar</button>
      </div>
    </div>
  </form>
</div>